// src/components/BannerCarousel.jsx
import React, { useState, useEffect } from 'react';

export default function BannerCarousel() {
  const banners = ['/banner1.jpg', '/banner2.jpg', '/banner3.jpg'];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setIndex(prev => (prev + 1) % banners.length);
    }, 4000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section
      className="relative w-full h-80 md:h-96 bg-cover bg-center text-white transition-all duration-700 m-0 p-0"
      style={{ backgroundImage: `url(${banners[index]})` }}
    >
      {/* Single Header in the Banner */}
      <div className="absolute top-0 left-0 right-0 flex justify-between items-center px-6 py-4 bg-black bg-opacity-50">
        <div>
          <h1 className="text-3xl font-bold">Low Wray Campsite</h1>
          <p className="text-sm">Camp Booking</p>
        </div>
        <div className="space-x-4">
          <button className="hover:text-blue-300 transition">Home</button>
          <button className="hover:text-blue-300 transition">About</button>
          <button className="hover:text-blue-300 transition">Contact</button>
        </div>
      </div>

      {/* Center Banner Text */}
      <div
        className="absolute inset-0 flex flex-col items-center justify-center text-center px-6 py-4 bg-black bg-opacity-70 rounded-md mx-4"
        style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8)' }}
      >
        <h2 className="text-3xl md:text-4xl font-bold mb-2">Explore the Lake District</h2>
        <p className="text-sm md:text-base">Scroll down to find your perfect pitch</p>
      </div>
    </section>
  );
}